import { z } from 'zod'

export const formSchema = z.object({
  email: z.string().email(),
  acceptTerms: z
    .union([z.string(), z.boolean()])
    .transform((value) => value === 'true' || value === true),
})
